import { createColumnHelper } from "@tanstack/react-table";
import dayjs from "dayjs";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  fetchVideoDownload,
  useVideoList,
} from "../../../../api/inquiries/video/use-video";
import Table from "../../../../components/ui/Table/Table";
import { convertDeltaToText, indexer } from "../../../../utils";

const options = [
  { id: 1, name: "최신순" },
  { id: 2, name: "최신순" },
  { id: 3, name: "최신순" },
];

const columnHelper = createColumnHelper();

const columns = (page, pageSize, total) => {
  return [
    columnHelper.accessor((row) => row, {
      header: "번호",
      cell: (info) => {
        const index = info.cell.row.index;
        const indexing = indexer(page, pageSize, total);

        return <div>{indexing(index)}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.title, {
      header: "제목",
      cell: (info) => {
        const val = info.getValue();
        const title = val?.length > 20 ? val?.substring(0, 20) + "..." : val;

        return <div>{val ? title : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.contents, {
      header: "내용",
      cell: (info) => {
        const val = info.getValue();
        const text = convertDeltaToText(JSON.parse(val));

        const contents =
          text?.length > 20 ? text?.substring(0, 20) + "..." : text;

        return val ? (
          <div
            dangerouslySetInnerHTML={{
              __html: contents,
            }}
          />
        ) : (
          <span>-</span>
        );
      },
    }),

    columnHelper.accessor((row) => row?.hitLog, {
      header: "게시글 조회수",
      cell: (info) => {
        const val = info.getValue();

        return <div>{val || 0}</div>;
      },
    }),

    columnHelper.accessor((row) => row.createdAt, {
      header: "등록일시",
      cell: (info) => {
        const val = info.getValue();
        const datetime = dayjs(val).format("YYYY-MM-DD HH:mm");
        return <div>{val ? datetime : "-"}</div>;
      },
    }),

    columnHelper.display({
      header: "자세히보기",
      id: "actions",
      cell: ButtonActions,
    }),
  ];
};

function ButtonActions(props) {
  const id = props.row.original?.id;
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(`video/${id}`)}
      className="w-10 p-[1px] border border-[#cccccc] rounded-[4px] text-[#333333]"
    >
      상세
    </button>
  );
}

export function VideoTable(props) {
  const { filter } = props;
  const { isEmpty, getDataTableProps } = useVideoList(filter);
  const currentPage = getDataTableProps().pagination?.pageIndex + 1;
  const pageSize = getDataTableProps().pagination?.pageSize;
  const totalData = getDataTableProps().total;

  const onSave = async () => {
    await fetchVideoDownload().then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `video-${Date.now()}.xlsx`);
      document.body.appendChild(link);
      link.click();
    });
  };

  return (
    <>
      {isEmpty ? (
        <div className="flex justify-center mt-[60px] text-[#999999] text-center">
          등록된 내역이 없습니다.
        </div>
      ) : (
        <Table
          hasAdditionalText={true}
          additionalText={
            "※ ONEDAY BIOTECH 제품소개 메뉴에 등록되는 동영상입니다."
          }
          onSave={onSave}
          hasPageSizeFilter={false}
          columns={columns(currentPage, pageSize, totalData)}
          sorts={options}
          {...getDataTableProps()}
        />
      )}
    </>
  );
}
